import { render, staticRenderFns } from "./ProgramDescription.vue?vue&type=template&id=a3819d9e&"
import script from "./ProgramDescription.vue?vue&type=script&lang=js&"
export * from "./ProgramDescription.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDescription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports